/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetNursingHomeQueryResponse,
  GetNursingHomePathParams,
  GetNursingHome404,
} from '../../types/GetNursingHome'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getNursingHome } from '../../clients/getNursingHome'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getNursingHomeQueryKey = ({
  nursinghome_id,
}: {
  nursinghome_id: GetNursingHomePathParams['nursinghome_id']
}) =>
  [
    {
      url: '/api/v1/nursing_home/:nursinghome_id/',
      params: { nursinghome_id: nursinghome_id },
    },
  ] as const

export type GetNursingHomeQueryKey = ReturnType<typeof getNursingHomeQueryKey>

export function getNursingHomeQueryOptions(
  {
    nursinghome_id,
  }: { nursinghome_id: GetNursingHomePathParams['nursinghome_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getNursingHomeQueryKey({ nursinghome_id })
  return queryOptions<
    GetNursingHomeQueryResponse,
    ResponseErrorConfig<GetNursingHome404>,
    GetNursingHomeQueryResponse,
    typeof queryKey
  >({
    enabled: !!nursinghome_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getNursingHome(
        { nursinghome_id: nursinghome_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Get nursing home detail
 * {@link /api/v1/nursing_home/:nursinghome_id/}
 */
export function useGetNursingHome<
  TData = GetNursingHomeQueryResponse,
  TQueryData = GetNursingHomeQueryResponse,
  TQueryKey extends QueryKey = GetNursingHomeQueryKey,
>(
  {
    nursinghome_id,
  }: { nursinghome_id: GetNursingHomePathParams['nursinghome_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetNursingHomeQueryResponse,
        ResponseErrorConfig<GetNursingHome404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getNursingHomeQueryKey({ nursinghome_id })

  const query = useQuery(
    {
      ...getNursingHomeQueryOptions({ nursinghome_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetNursingHome404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
